import React from 'react';
import { classNames } from '../atoms';

type GridColSpan = 'auto' | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;

export interface GridColProps extends React.HTMLAttributes<HTMLDivElement> {
  lg?: GridColSpan;
  md?: GridColSpan;
  sm?: GridColSpan;
  span?: GridColSpan;
  xl?: GridColSpan;
  xxl?: GridColSpan;
}

const getColClassName = (breakpoint: string, span?: GridColSpan): string | undefined => {
  if (span === undefined) return undefined;
  return breakpoint ? `col-${breakpoint}-${span}` : `col-${span}`;
};

const GridCol = React.forwardRef<HTMLDivElement, GridColProps>(({
  className,
  children,
  lg,
  md,
  sm,
  span,
  xl,
  xxl,
  ...props
}, ref) => (
  <div
    ref={ref}
    className={classNames(
      getColClassName('', span),
      getColClassName('sm', sm),
      getColClassName('md', md),
      getColClassName('lg', lg),
      getColClassName('xl', xl),
      getColClassName('xxl', xxl),
      className,
    )}
    {...props}
  >
    {children}
  </div>
));

GridCol.displayName = 'GridCol';

export default GridCol;
